import React from 'react'
import { Card, Button, Typography, Paper, Link, Stack, CardMedia, Grid } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";

import SEO from "../components/SEO";

import { Box } from '@mui/system';

import PhotoOne from "../assets/images/photo_one.jpg";
import PhotoTwo from "../assets/images/photo_two.jpg";
import PhotoThree from "../assets/images/photo_three.jpg";
import useMediaQuery from '@mui/material/useMediaQuery';


export default function About() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const style = {
        background: {
            //backgroundImage: `linear-gradient(transparent, white 50%), url(${background})`,
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '2%',
                marginRight: '2%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '10%',
                marginRight: '10%',
            },
        },
        typography: {
            fontWeight: "bold",
            opacity: 0.7,
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 35,
                textAlign: "center"
            }
        },
        bodyText: {
            paddingBottom: 4,
            marginTop: 2,
            letterSpacing: 1,
            opacity: 0.7,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                marginTop: 2,
            }
        },
        contactButton: {
            marginTop: 4,
            marginBottom: 4,
            paddingLeft: 10,
            border: '3px black solid',
            color: (theme) => theme.palette.common.black,
            paddingTop: 1,
            textTransform: "none",
            paddingBottom: 1,
            paddingRight: 10,
            opacity: 0.6,
            fontSize: 15,
            borderRadius: 5,
            boxShadow: 0,
            "&:hover": {
                border: '3px #3E73DB solid',
                color: (theme) => theme.palette.primary.main,
                opacity: 1,
            },
        },
        centerDiv: {
            '@media only screen and (max-width: 900px)': {
                textAlign: "center"
            }
        },
        memojiCenter: {
            display: "flex",
            '@media screen and (min-width: 900px)': {
                display: "none"
            }
        },
        memojiLeft: {
            '@media screen and (max-width: 900px)': {
                display: "none"
            }
        },
        cardMedia: {
            borderRadius: 0,
            minWidth: 200,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        linkText: {
            fontStyle: "italic",
            fontWeight: "bold",
            color: (theme) => theme.palette.primary.main
        },
        cardMediaLarge: {
            borderRadius: 0,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
    }
    const memojiBox = (
        <Stack
            sx={{ marginTop: matches ? 10 : 4, }}
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="center"
            spacing={2}
        >
            {matches &&
                <Stack direction="column" spacing={2}>
                    <Card sx={style.cardMedia}>
                        <CardMedia
                            component="img"
                            height={matches ? "200" : "300"}
                            image={PhotoOne}
                        />
                    </Card>
                    <Card sx={style.cardMedia}>
                        <CardMedia
                            component="img"
                            height={matches ? "200" : "300"}
                            image={PhotoTwo}
                        />
                    </Card>
                </Stack>
            }
            <Card sx={style.cardMediaLarge}>
                <CardMedia
                    component="img"
                    height={matches ? "416" : "300"}
                    image={PhotoThree}
                />
            </Card>
        </Stack>
    )
    return (
        <Box>
            <SEO title="About - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... About" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Stack
                        sx={style.centerDiv}
                        direction={{ xs: 'column', md: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 5 }}>
                        <Stack direction="row" spacing={2} >
                            <Box sx={{ marginTop: matches ? 10 : 4 }}>
                                <Typography sx={style.typography} variant="h1" color="default"> Reading is Fascinating</Typography>
                                <Typography sx={style.bodyText} variant={matches ? "h5" : "subtitle1"} color="default" display="inline"> Join and get access to the primary library and resource
                                    center of the local community. </Typography>
                                <Box >
                                    <Grid container columns={12} sx={style.memojiCenter}>
                                        <Grid item xs={12}>
                                            {memojiBox}
                                        </Grid>
                                    </Grid>
                                    <Link href="/mybooks/reserve" sx={{ textDecoration: "none" }}>
                                        <Button variant="outlined" sx={style.contactButton}>Get Started</Button>
                                    </Link>
                                    <Stack direction={matches ? "row" : "column"} spacing={1} alignItems={matches ? "left" : "center"}>
                                        <Typography variant="subtitle1">Found a book to your liking? </Typography>
                                        <Stack direction="row" spacing={1}>
                                            <Link href="/register">
                                                <Typography variant="subtitle1" sx={style.linkText}>Create an Account</Typography>
                                            </Link>
                                            <Typography variant="subtitle1">or</Typography>
                                            <Link href="/login">
                                                <Typography variant="subtitle1" sx={style.linkText}>Sign in</Typography>
                                            </Link>
                                        </Stack>
                                        <Typography variant="subtitle1">to reserve it now.</Typography>
                                    </Stack>
                                    <Box sx={{ height: 100 }} />
                                </Box>
                            </Box>
                            <Box sx={style.memojiLeft}>
                                {memojiBox}
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
